var exports = {
  "kL": "x804f0401--de75b1--container",
  "Qs": "x804f0401--de75b1--content",
  "wx": "x804f0401--de75b1--header",
  "Qq": "x804f0401--de75b1--text",
  "XI": "x804f0401--de75b1--action",
  "Sl": "x804f0401--de75b1--image",
};

module.exports = exports;
